import {createContext} from "react";
import {ClientEntity} from "@common-core/coat-operational-hierarchy-appsync-model";
import {CreatePlanNode} from "../view-model";
import {PlanController} from "./PlanController";

export const PlanContext = createContext<PlanController>({
  from: {} as ClientEntity,
  hierarchy: {} as ClientEntity,
  plan: {} as CreatePlanNode,
  onAllSelectionToggle: () => {},
  onNodeSelectionToggle: () => {}
});
